import { RouteComponentProps } from "react-router";
import { interface___is_logged } from "../../../interfaces/interface.logged";

//	P R O P S

export interface props___SbDigitalMenuViewPage extends RouteComponentProps<{ id: string; }>, interface___is_logged {

}

//	S T A T E

export interface state___SbDigitalMenuViewPage {

	digitalmenu___id: string,
	digitalmenu___props: any | null,
	digitalmenu___props___isLoading: boolean,

	digitalmenu___url__type: 'link' | 'qr' | 'key',
	digitalmenu___url: string,

	ionModal___MdDishEditModal___isOpen: boolean,
	ionModal___MdDishEditModal___target_id: string | null,
	ionModal___MdDishEditModal___target_category: string | null,

	ionToast___copied___isOpen: boolean,

}

//	S T A T E   D E F A U L T

export const state___SbDigitalMenuViewPage___default: state___SbDigitalMenuViewPage = {

	digitalmenu___id: '',
	digitalmenu___props: null,
	digitalmenu___props___isLoading: true,

	digitalmenu___url__type: 'link',
	digitalmenu___url: '',

	ionModal___MdDishEditModal___isOpen: false,
	ionModal___MdDishEditModal___target_id: null,
	ionModal___MdDishEditModal___target_category: null,

	ionToast___copied___isOpen: false,

}